import React from 'react';
import ConfigFile from '../components/configFile.json';
import './header.css';

const Environment = () => {

return (<>
    <div className="row">   
        <div className="col-sm-12 d-flex justify-content-center align-items-center">        
            {
                ConfigFile.Environment!=="PRODUCTION" && 
                (<div className='environmentTitle'> {ConfigFile.Environment} ENVIRONMENT</div>)
            }
        </div>     
  </div>
  </>
)
}
export default Environment;